import React from "react";

import { withFilterCars } from "./containers/containerFilterCars";
import { withCars } from "./containers/containerCars";

import styles from "./countOnPage.module.scss";

const CountOnPage = (props) => {
  const { filterCountUnits, filterCarsListItems, totalUnits } = props;
  const { page, count } = filterCarsListItems;
  const maxPage = count * page;
  const minPage = maxPage - count;

  return (
    <div className={styles.countOnPage}>
      {count === -1 ? (
        <span>
          {totalUnits !== filterCountUnits ? (
            <b>
              {filterCountUnits} из {totalUnits}
            </b>
          ) : (
            <b>{filterCountUnits}</b>
          )}
        </span>
      ) : (
        <span>
          <b>
            {filterCountUnits === 0 ? minPage : minPage + 1}-{maxPage >= filterCountUnits ? filterCountUnits : maxPage}
          </b>
          &nbsp;из&nbsp;<b>{filterCountUnits}</b>
        </span>
      )}
    </div>
  );
};

export default withFilterCars(withCars(React.memo(CountOnPage)));
